import styled, { css, keyframes } from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { motion } from 'framer-motion';

export const Popup = styled.div`
  gap: ${() => `${viewSizeCalculator(2)}`};
  align-items: flex-start;
  position: absolute;
  top: ${() => `${viewSizeCalculator(5.8)}`};
  left: ${() => `${viewSizeCalculator(1.25)}`};
  padding: ${() => `${viewSizeCalculator(1.5)}`};
  background-color: #ffffff;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  z-index: 100;
  color: #333333;
  height: 87vh;
  width: ${({ isAdvancedFilterVisible }) =>
    isAdvancedFilterVisible ? "80vw" : "25vw"};
  transform-origin: left;
  /* Initial state when hidden */
  transform: scaleX(0);
  opacity: 0;
  visibility: hidden;

  /* Apply transition */
  transition:
    width 0.7s ease,
    transform 0.7s ease 0.2s,
    opacity 0.3s ease 0.2s,
    visibility 0s linear 0.5s;

  /* When visible */
  ${({ isPopupVisible }) =>
    isPopupVisible
      ? `
      transform: scaleX(1);
      opacity: 1;
      visibility: visible;
      
    `
      : `
      transform: scaleX(0);
      opacity: 1;
      visibility: hidden;
    `}
`;

export const CenterPopup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(2)}`};

  position: absolute;
  top: ${() => `${viewSizeCalculator(0)}`};
  left: ${() => `${viewSizeCalculator(27)}`};

  padding: ${() => `${viewSizeCalculator(1.5)}`};

  background-color: ${({ isSelectionEmpty }) =>
    isSelectionEmpty ? "#F5F5F5" : "#FFFFFF"};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  transition: background-color 0.3s ease-in-out;
  z-index: 999;
  color: #333333;

  ${({ addPaddingtoBottom }) =>
    addPaddingtoBottom && `padding-bottom: ${viewSizeCalculator(35)};`}

  height: 87vh;
  width: 39.4vw;

  overflow-y: scroll;

  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
`;

export const RightPopup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};

  position: absolute;
  top: ${() => `${viewSizeCalculator(0)}`};
  left: ${() => `${viewSizeCalculator(69)}`};

  padding: ${() => `${viewSizeCalculator(1.5)}`};

  background-color: #ffffff;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;

  z-index: 999;
  color: #333333;

  ${({ addPaddingtoBottom }) =>
    addPaddingtoBottom && `padding-bottom: ${viewSizeCalculator(35)};`}

  height: 87vh;
  width: 31.20vw;

  overflow-y: scroll;

  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
`;

export const PopupScrollWrapper = styled.div`
  overflow-y: auto;
  ${({ fullHeight }) =>
    fullHeight
      ? // The left Popup has no overflow containment of its own, and this
        // wrapper renders below the PopupHeader. A plain height:100% therefore
        // makes (header + wrapper) taller than the panel and the overflow leaks
        // to the page (vertical scrollbar -> vw-sized panels then spill a few px
        // -> horizontal scrollbar). Cap the height to the parent minus the
        // header so the list scrolls inside the panel instead.
        `height: 100%;
         max-height: calc(100% - ${viewSizeCalculator(4)});`
      : `max-height: calc(87vh - ${viewSizeCalculator(5)}); // adjust based on your header/footer heights
         height: 100%;
         margin-bottom: ${viewSizeCalculator(3)};`}
  // padding-right: 0.5rem; // optional for scrollbar space
  /* WebKit (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Firefox */
  scrollbar-width: none;

  /* IE and Edge */
  -ms-overflow-style: none;
  transition: all 0.3s ease-in-out;
  will-change: transform;
`;

export const PopupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  // border: 1px solid red;
  max-height: fit-content;

  border-bottom: ${() => `${viewSizeCalculator(1, true)} solid #ebebeb`};

  padding: ${() => `0 ${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)}`}; // 0 0 1.25rem 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    width: ${() => `${viewSizeCalculator(1.9)}`};
    height: ${() => `${viewSizeCalculator(1.9)}`};
  }
  svg path {
  fill: #676565; /* grey */
    transition: fill 0.3s ease;
  }
  &:hover svg path {
    fill: #000000;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
  // padding-left: ${viewSizeCalculator(0.2)};
  opacity: ${({ disabled }) =>
    disabled ? 0.99 : 1};
  z-index: ${({ zIndex }) => zIndex};
  padding: ${() => `${viewSizeCalculator(0.625)} 0 ${viewSizeCalculator(0.625)} 0`};
`;

export const CheckboxLabel = styled.label`
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 0.8125rem
  font-weight: 400;

  cursor: pointer;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${() => `0 ${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.7)}`}; // 0 0 1.25rem 0;
  transition: all 0.3s ease-in-out;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap:  ${() => `${viewSizeCalculator(0.75)}`};
  margin-top: ${(props) =>
    props.isFirst ? `${viewSizeCalculator(1.5)}` : "0"};
  margin-bottom: ${() => `${viewSizeCalculator(1.5)}`};

  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1)}`};
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  
  svg {
    transition: transform 0.3s ease-in-out;
    width: ${() => `${viewSizeCalculator(0.85)}`};
    height: ${() => `${viewSizeCalculator(0.85)}`};
    transform: rotate(${(props) => (props.open ? "-90deg" : "90deg")});
    transform-origin: center;
  }
  padding-right: ${() => `${viewSizeCalculator(0.3)}`};
`;

export const TitleSection = styled.div`
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem

  width: ${() => `${viewSizeCalculator(20.5)}`}; // 20.5rem

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
`;

export const Reset = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 500;
  opacity: ${({ isDisabled }) => (isDisabled ? "30%" : "100%")};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  color: ${({ isDisabled }) => !isDisabled && "#007bff"};
  padding: ${() => `0 ${viewSizeCalculator(0.625)} 0 0`}; // 0 0 1.25rem 0;
`;

export const HospitalCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.75)}`};
  height: 100%;
`;

export const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.5)}`};
`;

export const CenterTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.75)}`};

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;

export const CenterTitle = styled.h4`
  font-size: ${() => `${viewSizeCalculator(1)}`};
  font-weight: 700;
`;

export const CenterDescription = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.75)}`};
  font-weight: 400;
  color: #333333;
  opacity: 60%;
`;

const scaleIn = keyframes`
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const NoKPISelectedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 75%;
  gap: ${() => `${viewSizeCalculator(2)}`};
  animation: ${scaleIn} 0.3s ease-in-out;

  svg {
    width: ${() => `${viewSizeCalculator(18.75)}`};
    height: ${() => `${viewSizeCalculator(18.75)}`};
  }
`;

export const NoKPISelectedDescription = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.813)}`};
  max-width: ${() => `${viewSizeCalculator(21.75)}`};
  line-height: 150%;
  font-weight: 600;
  color: #333333;
  text-align: center;
`;

export const WeightageContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const SingleWeightageWrapper = styled.div`
  display: flex;
  gap: ${() => `${viewSizeCalculator(2)}`};
  width: 100%;
  align-items: end;
  padding-bottom: ${({ isLast }) => isLast ? `${viewSizeCalculator(5)}` : `${viewSizeCalculator(1.5)}`};

  svg {
    cursor: pointer;
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
    margin-bottom: ${() => `${viewSizeCalculator(1)}`};
    opacity: 50%;
  }
`;

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};
  width: ${() => `${viewSizeCalculator(23.5)}`};
  justify-content: center;
  align-items: center;
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: ${viewSizeCalculator(0.063)} solid rgba(51, 51, 51, 0.1);
  margin-bottom: ${viewSizeCalculator(1.5)};
`;

export const WeightageInputContainer = styled.div`
  max-width: ${() => `${viewSizeCalculator(8.125)}`};
`; 

export const FixedButtonContainer = styled.div`
  position: absolute;
  bottom: ${() => `${viewSizeCalculator(1)}`};
  right: ${() => `${viewSizeCalculator(1.5)}`};
  display: flex;
  gap: ${() => `${viewSizeCalculator(1)}`};
  z-index: 1000;
`;

export const Button = styled.button`
  width: ${() => viewSizeCalculator(9.375)};
  height: ${() => viewSizeCalculator(2.5)};
  padding: ${() =>
    `${viewSizeCalculator(0.3125)} ${viewSizeCalculator(
      1,
    )} ${viewSizeCalculator(0.3125)} ${viewSizeCalculator(1)}`};
  border: ${({ borderColor }) =>
    `${viewSizeCalculator(0.0625)} solid ${borderColor}`};
  border-radius: ${() => viewSizeCalculator(1.25)};
  background-color: ${({ backgroundColor }) => backgroundColor};

  font-family: Inter;
  font-weight: 500;
  font-size: ${() => viewSizeCalculator(0.875)};
  line-height: ${() => viewSizeCalculator(1.3125)};
  letter-spacing: -2.2%;
  color: ${({ color }) => color};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: opacity 0.2s ease-in-out;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const TotalsText = styled.div`
  font-size: 13px;
  color: #666;
  font-weight: 500;
`;

export const Controls = styled.div`
  display: flex;
  gap: 6px;
`;

export const ControlButton = styled.button`
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
  background: #fff;
  color: #333;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover:not(:disabled) {
    background: #f5f5f5;
    border-color: #bbb;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;